import gql from 'graphql-tag';

export default gql`
  mutation DeleteAppPremiumValuationReport($accountId: ID!, $id: ID!) {
    deleteAppPremiumValuationReport(accountId: $accountId, id: $id) {
      __typename
    }
  }
`;
